import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CoreGymService } from '../core.gym.service.service';

/**
 * EmployeeInviteService — Task #46/#48. Mirrors login.service.ts's shape (same CoreGymService
 * BaseUrl/serviceUrls convention). Backs EmployeeInviteController.cs (api/employee-invites):
 *   POST   api/employee-invites          -> Create   (Authorize; caller's own tenant is resolved
 *                                            server-side from the bearer token, not sent by the client)
 *   GET    api/employee-invites/pending  -> Pending   (Authorize)
 *   GET    api/employee-invites/validate -> Validate  (anonymous — invitee has no session yet)
 *   POST   api/employee-invites/accept   -> Accept    (anonymous)
 */
@Injectable({ providedIn: 'root' })
export class EmployeeInviteService {

  constructor(
    private readonly http: HttpClient,
    private readonly coreGymService: CoreGymService,
  ) { }

  createInvite(email: string, fullName: string | null, roleCode: string): Observable<any> {
    const headers = new HttpHeaders().append('Content-Type', 'application/json');
    const url = this.coreGymService.BaseUrl! + this.coreGymService.serviceUrls!['EmployeeInviteCreateUrl'];
    return this.http.post(url, { email, fullName, roleCode }, { headers })
      .pipe(catchError((e: HttpErrorResponse) => throwError(() => e)));
  }

  getPendingInvites(): Observable<any> {
    const url = this.coreGymService.BaseUrl! + this.coreGymService.serviceUrls!['EmployeeInvitePendingUrl'];
    return this.http.get(url)
      .pipe(catchError((e: HttpErrorResponse) => throwError(() => e)));
  }

  validateToken(token: string): Observable<any> {
    const url = this.coreGymService.BaseUrl! + this.coreGymService.serviceUrls!['EmployeeInviteValidateUrl'];
    const params = new HttpParams().set('token', token);
    return this.http.get(url, { params })
      .pipe(catchError((e: HttpErrorResponse) => throwError(() => e)));
  }

  acceptInvite(token: string, fullName: string, password: string): Observable<any> {
    const headers = new HttpHeaders().append('Content-Type', 'application/json');
    const url = this.coreGymService.BaseUrl! + this.coreGymService.serviceUrls!['EmployeeInviteAcceptUrl'];
    return this.http.post(url, { token, fullName, password }, { headers })
      .pipe(catchError((e: HttpErrorResponse) => throwError(() => e)));
  }
}
